import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "40",
  height: "34",
  x: "4",
  y: "8",
  stroke: "#155EEF",
  "stroke-width": "2",
  rx: "7"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#155EEF",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12.5 20.375c0-.815 0-1.223.133-1.545a1.75 1.75 0 0 1 .947-.947c.322-.133.73-.133 1.545-.133h8.75c.815 0 1.223 0 1.545.133.428.178.77.518.947.947.133.322.133.73.133 1.545M16 31.75h7m-5.031-14v14m3.062-14v14M35 15v18"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }